import * as React from "react";
import {Stack, Typography, Grid, Button, Card, CardContent, CardMedia, Box} from '@mui/material';
import {ReactComponent as People} from "../../icon/People.svg";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import axios from "../../axios";
import {shortDateFormat, formatHour, truncateStr} from ".././Service";
import {withJoinContext} from "./joinContext";
import {useJoin} from "./hooks/useJoin";
import {useScreen} from "./hooks/useScreen";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {useSynchronisation} from "../event/hooks/useSynchronisation";
import {removeHtml} from ".././Service";
import {formatToVcalendarDate} from ".././Service";
import parse from "html-react-parser";

const EventCard = ({theEvent}) => {
    const {changeScreen} = useScreen();
    const {createEvent, deleteEvent, createCalendar} = useSynchronisation();
    const {join, joinStatus ,leave} = useJoin({
        isJoin:theEvent.is_member,
        memberCount: theEvent.member_count
    });
   const handleClickJoin = (isJoin) => {
        if (isJoin) {
            join(theEvent.id);
            //createCalendar();
            createEvent(removeHtml(theEvent.description), theEvent.title.text, formatToVcalendarDate(theEvent.start_date), formatToVcalendarDate(theEvent.end_date), theEvent.location.text, theEvent.id);
        } else {
            deleteEvent(theEvent.id)
            leave(theEvent.id)
        }
   }


   console.log(theEvent);
    const handleSeeEventDetail = () => {
        console.log('theEvent',theEvent)
        changeScreen(2, theEvent);
    };
    const {mode} = useDarkMode();
    return (
        <Card sx={{width:383}} style={{backgroundColor : mode.settings.cardBackgroundColor}}>
            <CardContent>
                <Stack
                    direction="column"
                    justifyContent="left"
                    alignItems="flex-start"
                    spacing={1}
                >
                    <Typography variant={'body3'} style={{color : mode.settings.textColor3}}>
                        {parse(truncateStr(theEvent.title.text, 35))}
                    </Typography>
                    <Stack
                        direction="row"
                        justifyContent="left"
                        alignItems="center"
                        spacing={1}
                    >
                        <People style={{color : mode.settings.textColor3}}></People>
                        <Typography variant={'subtitle3'} style={{color : mode.settings.textColor3}}>
                            {joinStatus.memberCount} participant{joinStatus.memberCount > 1 ? 's' : ''}
                        </Typography>
                    </Stack>

                    <Box
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            backgroundImage: `url(${axios.defaults.apiBaseURL}/${theEvent.image.uri})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />
                    {
                        shortDateFormat(theEvent.start_date) !== shortDateFormat(theEvent.end_date) ?
                            <Stack
                                direction="row"
                                justifyContent="left"
                                alignItems="flex-start"
                                flexWrap={'nowrap'}
                                sx={{color: mode.settings.textColor6}}
                            >
                                <CalendarMonthIcon
                                    sx={{marginRight: 0.5}}
                                    aria-label={"Date de début de l'évenement"}></CalendarMonthIcon>
                                <Typography variant={'subtitle3'}>
                                    {shortDateFormat(theEvent.start_date)}
                                    &nbsp;à&nbsp;
                                    {formatHour(theEvent.start_date)} au&nbsp;
                                    {
                                        shortDateFormat(theEvent.end_date) + ' à ' + formatHour(theEvent.end_date)
                                    }
                                </Typography>

                            </Stack> :
                            <Stack
                                direction="row"
                                justifyContent="left"
                                alignItems="flex-end"
                                sx={{color: mode.settings.textColor6}}
                                flexWrap={'wrap'}>
                                <CalendarMonthIcon
                                    sx={{marginRight: 0.5}}
                                    aria-label={"Date de début de l'évenement"}></CalendarMonthIcon>
                                <Typography variant={'subtitle3'}>
                                    {shortDateFormat(theEvent.start_date)}
                                </Typography>
                                <AccessTimeIcon
                                    sx={{marginLeft: 2, marginRight: 0.5}}
                                    aria-label={"Heure de l'évenement événement"}></AccessTimeIcon>
                                <Typography variant={'subtitle3'} sx={{marginRight: 2}}>
                                    {formatHour(theEvent.start_date)} à&nbsp;
                                    {formatHour(theEvent.end_date)}
                                </Typography>
                            </Stack>
                    }
                    <Stack
                        direction="row"
                        justifyContent="left"
                        alignItems="flex-end"
                        sx={{color: mode.settings.textColor6}}
                    >
                        <LocationOnIcon ></LocationOnIcon>
                        <Typography variant={'subtitle3'}>{truncateStr(theEvent.location.text, 30)}</Typography>
                    </Stack>
                    <Typography
                        sx={{marginTop: 1, height: 55}}
                        variant={'subtitle3'}
                        style={{color : mode.settings.textColor3}}
                        dangerouslySetInnerHTML={{__html:  truncateStr(theEvent.description, 45) }}
                    />
                    <Button
                        className="btn-gradient"
                        variant="contained"
                        size="large"
                        startIcon={<RemoveRedEyeIcon role="img" aria-label={"Voir le detail"} />}
                        sx={{width: '100%', marginTop: 2}}
                        onClick={handleSeeEventDetail}
                        aria-label={"Voir le détail de l'évenement"}
                    >
                        <Typography variant={'subtitle3'}>Voir le detail</Typography>
                    </Button>
                    {joinStatus.isJoin === true ?
                        <Button
                            className="btn-gradient"
                            variant="contained"
                            size="large"
                            startIcon={<LogoutIcon role="img" aria-label={"Quitter cet événement"}/>}
                            sx={{width: '100%', marginTop: 2}}
                            onClick={() => handleClickJoin(false)}
                            aria-label={"Quitter cet événement"}
                        >
                            <Typography variant={'subtitle3'}>Quitter cet évènement</Typography>
                        </Button>
                        :
                        <Button
                            className="btn-gradient"
                            variant="contained"
                            size="large"
                            startIcon={<LoginIcon role="img" aria-label={"Rejoindre cet événement"}/>}
                            sx={{width: '100%', marginTop: 2}}
                            onClick={() => handleClickJoin(true)}
                            aria-label={"Rejoindre cet événement"}
                        >
                            <Typography variant={'subtitle3'}>Rejoindre cet évènement</Typography>
                        </Button>
                    }
                </Stack>
            </CardContent>
        </Card>
    )
}

export default withJoinContext(EventCard);
